import { render, staticRenderFns } from "./table.vue?vue&type=template&id=0a9471da"
import script from "./table.ts?vue&type=script&lang=ts&external"
export * from "./table.ts?vue&type=script&lang=ts&external"
import style0 from "./table.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports